import cattogirl from "../../images/yukaicourse.gif";
import catstoryboard from "../../images/DMK_Storyboard.jpg";
import styleframe1 from "../../images/DMK_Styleframes_01.jpg";
import styleframe2 from "../../images/DMK_Styleframes_02.png";
import styleframe3 from "../../images/DMK_Styleframes_03_cat.jpg";
export default function Nostalgia() {
  return (
    <div>
      <div className="header">
        <h1>Cat to Girl</h1>
        <p>
          This was my a project that I completed in July 2022 from Yukai Du's
          course on Domestika. It was my first time doing cel-animation and I
          got familiar with Adobe Animate.
        </p>
        <img className="full-img" src={catstoryboard} />
        <p>
          I drew out the stills in Photoshop, which were then taken into Adobe
          Animate to draw out the in-between frames. I learned about onion skins
          and use it to draw out the frames for every 4 secs, then every 2 secs.
        </p>
        <div className="three-column-img">
          <img className="small-img" src={styleframe1} />
          <img className="small-img" src={styleframe2} />
          <img className="small-img" src={styleframe3} />
        </div>
        <p>
          The final GIF is a girl turning into a cat and then back to a girl.{" "}
        </p>
        <img className="full-img" src={cattogirl} />
      </div>
    </div>
  );
}
